import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Comment from '~/components/comments/Comment.vue';
import Form from '~/components/comments/Form.vue';
import Card from '~/components/cards/Card.vue';
import Collapse from '~/components/collapse/Collapse.vue';
import CollapseButton from '~/components/collapse/Button.vue';
export default {
  components: {
    Comment: Comment,
    Form: Form,
    Card: Card,
    Collapse: Collapse,
    CollapseButton: CollapseButton,
    MaterialGallery: function MaterialGallery() {
      return import('~/components/overlays/MaterialGallery.vue');
    },
    Overlay: function Overlay() {
      return import('~/components/overlays/Overlay.vue');
    }
  },
  name: 'comments',
  props: {
    modelName: String,
    modelId: String,
    collapseGroup: String,
    mobileCompact: Boolean,
    newCase: Boolean,
    chatMode: Boolean
  },
  data: function data() {
    return {
      ready: false,
      user: null,
      comments: [],
      length: 0,
      newThreadsCount: 0,
      drafts: [],
      gallery: [],
      currentGalleryIndex: 0
    };
  },
  computed: {
    collpaseId: function collpaseId() {
      return "comments-".concat(this.modelName, "-").concat(this.modelId);
    },
    compact: function compact() {
      return ['xs', 'sm'].indexOf(this.$mq) >= 0 && this.mobileCompact;
    },
    collapseStore: function collapseStore() {
      return useCollapseStore();
    },
    topDraft: function topDraft() {
      return this.drafts.find(function (o) {
        return !o.parent;
      });
    },
    isLastImage: function isLastImage() {
      return this.currentGalleryIndex >= this.gallery.length - 1;
    },
    isFirstImage: function isFirstImage() {
      return this.currentGalleryIndex <= 0;
    }
  },
  watch: {
    compact: function compact(val) {
      if (val) this.collapseStore.remove(this.collpaseId);else this.collapseStore.add(this.collpaseId);
    },
    ready: function ready(val) {
      var _this = this;
      if (val && this.chatMode) {
        this.$nextTick(function () {
          _this.scrollBottom();
        });
      }
    }
  },
  beforeMount: function beforeMount() {
    this.enterRoom();
    this.$socket.on('deleteComment', this.deleteComment);
    this.$socket.on('newComment', this.newComment);
    this.$socket.on('hideComment', this.hideReply);
    this.$socket.on('showComment', this.showReply);
    this.$socket.on('updateComment', this.updateReply);
    this.$socket.on('updateLength', this.updateLength);
    this.$socket.on('commentDraft', this.updateDraft);
    this.$socket.on('draftSent', this.removeDraft);
  },
  mounted: function mounted() {
    if (this.chatMode && this.ready) this.scrollBottom();
  },
  methods: {
    scrollBottom: function scrollBottom() {
      if (this.$refs.comments) {
        this.$refs.comments.scrollTop = this.$refs.comments.scrollHeight;
      }
    },
    enterRoom: function enterRoom() {
      var _this2 = this;
      if (this.modelName && this.modelId) {
        var params = {
          model: this.modelName,
          id: this.modelId,
          dataonly: true
        };
        this.$socket.get('/comment/enterRoom', params, function (resData, jwres) {
          if (jwres.statusCode !== 200) {
            console.log(jwres.statusCode);
            console.log(jwres);
            return console.error('error');
          }
          _this2.user = resData.user;
          _this2.ready = true;
          _this2.length = resData.length;
          var records = _this2.chatMode ? resData.comments.reverse() : resData.comments;
          var comments = [];
          var drafts = [];
          records.forEach(function (o) {
            if (o.isDraft) drafts.push(o);else comments.push(o);
          });
          _this2.comments = comments;
          _this2.drafts = drafts;
        });
      }
    },
    loadComments: function loadComments(_ref) {
      var _this3 = this;
      var parent = _ref.parent,
        cb = _ref.cb;
      var params = {};
      var index;

      // Load rest of childs
      if (parent) {
        params = {
          parent: parent
        };
        index = this.comments.findIndex(function (o) {
          return o.id == parent;
        });
        if (index < 0) {
          return console.error('Parent not found to load chlds');
        }

        // Load new parent comments
      } else {
        var exclude = [];
        if (this.comments.length) {
          exclude = this.comments.map(function (o) {
            return o.id;
          });
        }
        params = {
          postModel: this.modelName,
          postId: this.modelId,
          id: {
            '!': exclude
          },
          parent: null,
          isDraft: {
            '!': true
          }
        };
      }
      this.$socket.get('/comment/get', params, function (resData, jwres) {
        if (jwres.statusCode !== 200) return console.error('error');
        if (parent) {
          _this3.comments[index].childs = resData;
        } else {
          var _this3$comments;
          (_this3$comments = _this3.comments).unshift.apply(_this3$comments, _toConsumableArray(resData));

          // Log unmatch
          if (resData.length !== _this3.newThreadsCount) {
            var diff = _this3.newThreadsCount - resData.length;
            console.log(_this3.newThreadsCount, resData.length);
            console.warn("OOOPS! \uD83D\uDE2B");
            console.warn("Looks like we lost ".concat(diff, " comments \uD83D\uDCAC"));
          }
          _this3.newThreadsCount = 0;
        }
        if (cb) cb();
      });
    },
    placeComments: function placeComments(comments) {
      var _this4 = this;
      comments.forEach(function (comment) {
        // Let's find your momy 🍭
        if (comment.parent) {
          var index = _this4.comments.findIndex(function (o) {
            return o.id == comment.parent;
          });
          if (index < 0) {
            console.warn('Got new comment but it\'s thread is not found');
            return true;
          }
          _this4.comments[index].childs.push(comment);
        } else {
          if (_this4.chatMode) {
            _this4.comments.push(comment);

            // Scroll chat to the bottom if user scroll if not more that 700px from end 
            _this4.$nextTick(function () {
              _this4.$nextTick(function () {
                // Double `$nextTick` to ensure DOM updates
                _this4.$nextTick(function () {
                  if (_this4.$refs.comments) {
                    var _this4$$refs$comments = _this4.$refs.comments,
                      scrollTop = _this4$$refs$comments.scrollTop,
                      scrollHeight = _this4$$refs$comments.scrollHeight,
                      clientHeight = _this4$$refs$comments.clientHeight;
                    if (scrollTop + clientHeight + 700 >= scrollHeight) {
                      requestAnimationFrame(function () {
                        return _this4.scrollBottom();
                      });
                    }
                  }
                });
              });
            });
          } else {
            _this4.comments.unshift(comment);
          }
        }
      });
    },
    deleteComment: function deleteComment(comment) {
      // Let's find your momy 🍭
      if (comment.parent) {
        var i = this.comments.findIndex(function (o) {
          return o.id == comment.parent;
        });
        if (i < 0) return true;
        var j = this.comments[i].childs.findIndex(function (o) {
          return o.id == comment.id;
        });
        if (j < 0) return true;
        this.comments[i].childs.splice(j, 1);
      } else {
        var index = this.comments.findIndex(function (o) {
          return o.id == comment.id;
        });
        if (index < 0) return true;
        this.comments.splice(index, 1);
      }
      this.$emit('deleteComment', comment);
    },
    placeReports: function placeReports(_ref2) {
      var reports = _ref2.reports,
        commentId = _ref2.commentId,
        parentId = _ref2.parentId;
      if (parentId && parentId !== commentId) {
        var parentIndex = this.comments.findIndex(function (o) {
          return o.id == parentId;
        });
        if (parentIndex < 0) return console.error('Can\'t find parent comment');
        var index = this.comments[parentIndex].childs.findIndex(function (o) {
          return o.id == commentId;
        });
        if (index < 0) return console.error('Can\'t find comment in parent');
        this.comments[parentIndex].childs[index].reports.push(reports);
      } else {
        var _index = this.comments.findIndex(function (o) {
          return o.id == commentId;
        });
        if (_index < 0) return console.error('Can\'t find comment');
        this.comments[_index].reports.push(reports);
      }
    },
    newReply: function newReply(data) {
      var index = this.comments.findIndex(function (o) {
        return o.id == data.parent;
      });

      // Parent comment is already shown on page
      if (index >= 0) {
        this.comments[index].hiddenChilds++;
        this.comments[index].lastChildUser = data.user;
        // This is a reply to a new comment that no shown yet
      } else {
        this.newThreadsCount++;
      }
    },
    hideReply: function hideReply(data) {
      var index = this.comments.findIndex(function (o) {
        return o.id == data.id;
      });
      if (index < 0) return;
      this.comments[index].hidden = true;
      if (!this.user) return;
      if (this.user.isModer || this.comments[index].user && this.user.id == this.comments[index].user.id) this.comments[index].hideText = data.hideText;
    },
    showReply: function showReply(data) {
      var index = this.comments.findIndex(function (o) {
        return o.id == data.id;
      });
      if (index < 0) return;
      this.comments[index].hidden = false;
      this.comments[index].hideText = '';
    },
    updateReply: function updateReply(data) {
      var id = data.parent ? data.parent : data.id;
      var index = this.comments.findIndex(function (o) {
        return o.id == id;
      });
      if (index < 0) return;
      if (!data.parent) {
        Object.assign(this.comments[index], data.update);
      } else {
        var childIndex = this.comments[index].childs.findIndex(function (o) {
          return o.id == data.id;
        });
        if (childIndex < 0) return;
        Object.assign(this.comments[index].childs[childIndex], data.update);
      }
    },
    updateLength: function updateLength(length) {
      this.length = length;
      this.$emit('updateLength', length);
    },
    newComment: function newComment(data) {
      if (data.parent) {
        this.newReply(data);
      } else {
        if (this.chatMode) this.placeComments(data.comments);else this.newThreadsCount++;
      }
      this.increaseLength();
      this.$emit('newReply');
    },
    increaseLength: function increaseLength() {
      this.length++;
    },
    write: function write() {
      var _this5 = this;
      this.$scrollTo(this.$refs.form.$el, {
        offset: -100,
        onDone: function onDone() {
          _this5.$refs.form.setFocus();
        }
      });
    },
    showComments: function showComments() {
      this.collapseStore.add(this.collpaseId);
    },
    updateDraft: function updateDraft(draft) {
      if (!draft || draft.postModel !== this.modelName || draft.postId !== this.modelId) return;
      var draftIdex = this.drafts.findIndex(function (o) {
        return o.id == draft.id;
      });
      if (draftIdex >= 0) this.drafts.splice(draftIdex, 1, draft);else this.drafts.push(draft);
    },
    removeDraft: function removeDraft(draft) {
      var draftIdex = this.drafts.findIndex(function (o) {
        return o.id == draft.id;
      });
      if (draftIdex >= 0) this.drafts.splice(draftIdex, 1);
    },
    nextImage: function nextImage() {
      if (typeof this.currentGalleryIndex == 'undefined') return this.currentGalleryIndex = 0;
      if (this.currentGalleryIndex >= this.gallery.length - 1) {
        return this.currentGalleryIndex = this.gallery.length - 1;
      }
      document.getElementById('cases-overlay').scrollTop = 0;
      this.currentGalleryIndex++;
    },
    prevImage: function prevImage() {
      if (typeof this.currentGalleryIndex == 'undefined') return this.currentGalleryIndex = 0;
      if (this.currentGalleryIndex <= 0) return this.currentGalleryIndex = 0;
      document.getElementById('cases-overlay').scrollTop = 0;
      this.currentGalleryIndex--;
    },
    openGallery: function openGallery(_ref3) {
      var gallery = _ref3.gallery,
        index = _ref3.index;
      this.gallery = gallery;
      this.currentGalleryIndex = index;
      this.$modalityStore.openModal({
        type: 'overlay',
        name: 'comment-upload-gallery'
      });
      document.getElementById('main-app').click();
    }
  },
  destroyed: function destroyed() {
    this.$socket.off('newComment', this.newComment);
    this.$socket.off('hideComment', this.hideReply);
    this.$socket.off('showComment', this.showReply);
    this.$socket.off('updateComment', this.updateReply);
    this.$socket.off('updateLength', this.updateLength);
    this.$socket.off('commentDraft', this.updateDraft);
    this.$socket.off('draftSent', this.removeDraft);
  }
};